import moment from 'moment';

function getCurrentDayRange() {
  const today = new Date();
  const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
  const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);

  return [startOfDay.getTime(), endOfDay.getTime()];
}

function getYesterdayRange() {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const startOfDay = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0, 0);
  const endOfDay = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59, 999);

  return [startOfDay.getTime(), endOfDay.getTime()];
}

function getLastThreeDaysRange() {
  const today = new Date();
  const threeDaysAgo = new Date(today);
  threeDaysAgo.setDate(today.getDate() - 3);

  const startOfDay = new Date(threeDaysAgo.getFullYear(), threeDaysAgo.getMonth(), threeDaysAgo.getDate(), 0, 0, 0, 0);
  const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);

  return [startOfDay.getTime(), endOfDay.getTime()];
}

function getLastSevenDaysRange() {
  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);

  const startOfDay = new Date(sevenDaysAgo.getFullYear(), sevenDaysAgo.getMonth(), sevenDaysAgo.getDate(), 0, 0, 0, 0);
  const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);

  return [startOfDay.getTime(), endOfDay.getTime()];
}

function getLastThirtyDaysRange() {
  const today = new Date();
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(today.getDate() - 30);

  const startOfDay = new Date(
    thirtyDaysAgo.getFullYear(),
    thirtyDaysAgo.getMonth(),
    thirtyDaysAgo.getDate(),
    0,
    0,
    0,
    0
  );
  const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);

  return [startOfDay.getTime(), endOfDay.getTime()];
}

// Function to get the range for the last month
function getPreviousMonthRange() {
  const today = new Date();

  // Calculate the first day of the previous month
  const firstDayOfPreviousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

  // Calculate the last day of the previous month
  const lastDayOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);

  return [firstDayOfPreviousMonth.getTime(), lastDayOfPreviousMonth.getTime()];
}

const defaultDates = selectedValue => {
  const defaultDatesArray = [
    { label: 'justCustomRange', computedLabel: '', value: [null, null], isSelected: false },
    { label: 'justAll', computedLabel: 'justAll', value: getCurrentDayRange(), isSelected: true },
    { label: 'justYesterday', computedLabel: 'justYesterday', value: getYesterdayRange(), isSelected: false },
    {
      label: 'justLastThreeDays',
      computedLabel: 'justLastThreeDays',
      value: getLastThreeDaysRange(),
      isSelected: false,
    },
    {
      label: 'justLastSevenDays',
      computedLabel: 'justLastSevenDays',
      value: getLastSevenDaysRange(),
      isSelected: false,
    },
    {
      label: 'justLastThirtyDays',
      computedLabel: 'justLastThirtyDays',
      value: getLastThirtyDaysRange(),
      isSelected: false,
    },
    { label: 'justLastMonth', computedLabel: 'justLastMonth', value: getPreviousMonthRange(), isSelected: false },
  ];

  if (selectedValue) {
    // URL 参数解析出的时间戳是字符串，需先转回数字，否则 moment 无法解析且与预设范围永远不相等
    const normalizedValues = (Array.isArray(selectedValue) ? selectedValue : [selectedValue]).map(item =>
      typeof item === 'string' && /^\d+$/.test(item) ? Number(item) : item
    );
    const selectedDateString = normalizedValues.map(item => moment(item).format('YYYY-MM-DD')).join('');

    const selectedDatesArray = defaultDatesArray.map(date => {
      // justAll 不会写入 URL，URL 中出现的今天范围应视为自定义范围而非 All
      if (date.label === 'justAll') {
        return { ...date, isSelected: false };
      }

      const valueString = date.value.map(item => moment(item).format('YYYY-MM-DD')).join('');

      if (selectedDateString === valueString) {
        return { ...date, isSelected: true };
      }

      return { ...date, isSelected: false };
    });

    if (selectedDatesArray.every(date => !date.isSelected)) {
      selectedDatesArray[0] = { ...selectedDatesArray[0], value: normalizedValues, isSelected: true };
    }

    return selectedDatesArray;
  }

  return defaultDatesArray;
};

const getNewChoiceValuesAndChoiceValuesAfterSearchIfNewValueIsAll = currentFilter => {
  const choiceValues = currentFilter.choiceValues.map(choiceValue => {
    if (choiceValue.value !== 'All') {
      return { ...choiceValue, isSelected: false };
    }

    return { ...choiceValue, isSelected: true };
  });

  const choiceValuesAfterSearch = currentFilter.choiceValuesAfterSearch.map(choiceValue => {
    if (choiceValue.value !== 'All') {
      return { ...choiceValue, isSelected: false };
    }

    return { ...choiceValue, isSelected: true };
  });

  return { choiceValues, choiceValuesAfterSearch };
};

const getNewChoiceValuesAndChoiceValuesAfterSearchIfNotAll = (currentFilter, newValue) => {
  const choiceValues = currentFilter.choiceValues.map(choiceValue => {
    if (choiceValue.value === newValue) {
      return { ...choiceValue, isSelected: !choiceValue.isSelected };
    }
    if (choiceValue.value === 'All') {
      return { ...choiceValue, isSelected: false };
    }
    return { ...choiceValue };
  });

  const choiceValuesAfterSearch = currentFilter.choiceValuesAfterSearch.map(choiceValue => {
    if (choiceValue.value === newValue) {
      return { ...choiceValue, isSelected: !choiceValue.isSelected };
    }
    if (choiceValue.value === 'All') {
      return { ...choiceValue, isSelected: false };
    }
    return { ...choiceValue };
  });

  return { choiceValues, choiceValuesAfterSearch };
};

const getNewChoiceValuesAndChoiceValuesAfterSearchIfNotAllAndTypeBoolean = (currentFilter, newValue) => {
  const choiceValues = currentFilter.choiceValues.map(choiceValue => {
    if (choiceValue.value === newValue) {
      return { ...choiceValue, isSelected: true };
    }
    return { ...choiceValue, isSelected: false };
  });

  const choiceValuesAfterSearch = currentFilter.choiceValuesAfterSearch.map(choiceValue => {
    if (choiceValue.value === newValue) {
      return { ...choiceValue, isSelected: true };
    }
    return { ...choiceValue, isSelected: false };
  });

  return { choiceValues, choiceValuesAfterSearch };
};

function processChoiceValues(obj, allParams, currentCustomFilter, prevModifiedFilters = {}) {
  const resultObj = {};
  const isCustomFilter = Object.keys(currentCustomFilter).length > 0;

  Object.keys(obj).forEach(key => {
    const choiceValues = obj[key].choiceValues;
    const processedValues = [];
    const currentFilterSelectedValues = isCustomFilter
      ? currentCustomFilter.query[key]
      : allParams[obj[key].query_param];
    // 筛选组件是否展示由用户勾选决定，选 All（URL 无参数）时也需保留在筛选栏上
    const wasDisplayed = Boolean(prevModifiedFilters[key] && prevModifiedFilters[key].isDisplayed);

    if (Array.isArray(choiceValues) && choiceValues.length > 0) {
      if (typeof choiceValues[0] === 'object') {
        processedValues.push({
          name: 'justAll',
          value: 'All',
          isSelected: currentFilterSelectedValues === undefined,
        });

        if (obj[key].inputType === 'inputBoolean') {
          processedValues.push({
            name: 'justYes',
            value: 'True',
            isSelected: isCustomFilter ? currentFilterSelectedValues === true : currentFilterSelectedValues === 'True',
          });
          processedValues.push({
            name: 'justNo',
            value: 'False',
            isSelected: isCustomFilter
              ? currentFilterSelectedValues === false
              : currentFilterSelectedValues === 'False',
          });
        } else {
          // 确保 currentFilterSelectedValues 是数组，避免字符串 includes 子串匹配问题
          const selectedValues = Array.isArray(currentFilterSelectedValues)
            ? currentFilterSelectedValues
            : currentFilterSelectedValues
            ? [currentFilterSelectedValues]
            : [];

          choiceValues.forEach(item => {
            if (selectedValues.length === 0) {
              processedValues.push({
                ...item,
                isSelected: false,
              });
            } else {
              processedValues.push({
                ...item,
                isSelected: isCustomFilter
                  ? selectedValues.includes(item.value)
                  : selectedValues.includes(item.value.toString()),
              });
            }
          });
        }
      } else if (obj[key].inputType === 'inputDate') {
        resultObj[key] = {
          ...obj[key],
          choiceValues: defaultDates(currentFilterSelectedValues),
          isDisplayed: Boolean(currentFilterSelectedValues) || wasDisplayed,
        };
        return;
      } else if (obj[key].inputType === 'inputRange') {
        resultObj[key] = {
          ...obj[key],
          choiceValues: obj[key].choiceValues,
          enteredValues: currentFilterSelectedValues ?? [],
          isDisplayed: Boolean(currentFilterSelectedValues) || wasDisplayed,
        };
        return;
      } else {
        resultObj[key] = {
          ...obj[key],
          selectedValues: [],
          isDisplayed: Boolean(currentFilterSelectedValues) || wasDisplayed,
        };
        return;
      }
    } else if (obj[key].inputType === 'inputStr') {
      let value = '';
      if (currentFilterSelectedValues) value += currentFilterSelectedValues;

      resultObj[key] = { ...obj[key], value, isDisplayed: Boolean(currentFilterSelectedValues) || wasDisplayed };
      return;
    }

    resultObj[key] = {
      ...obj[key],
      choiceValues: processedValues,
      choiceValuesAfterSearch: [...processedValues],
      isDisplayed: currentFilterSelectedValues !== undefined || wasDisplayed,
    };
  });

  return resultObj;
}

export {
  defaultDates,
  getNewChoiceValuesAndChoiceValuesAfterSearchIfNewValueIsAll,
  getNewChoiceValuesAndChoiceValuesAfterSearchIfNotAll,
  getNewChoiceValuesAndChoiceValuesAfterSearchIfNotAllAndTypeBoolean,
  processChoiceValues,
};
